import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface PaneWarningsProps {
  messages: Array<string>;
}

/**
 * Warning icon used by `Pane`. It renders a `Popover` around the icon with the contents of `messages`.
 */
export default function PaneWarningsIcon({messages}: PaneWarningsProps): JSX.Element | null {
  if (messages.length === 0) {
    return null;
  }
  const content =
    messages.length === 1 ? (
      <>{messages[0]}</>
    ) : (
      <>
        {messages.map((message, messageIndex) => (
          <p key={messageIndex}>{message}</p>
        ))}
      </>
    );

  return (
    // Popover defaults to dialog, but this is not interactive, so it should be a tooltip. We can't use
    // `Tooltip` because that requires a flat string, and this has HTML.
    <Popover renderContent={() => content} placement={FloatingPlacement.BOTTOM} role="tooltip">
      <BenchlingIcon
        dataTestAttrs={{component: 'PaneWarningsIcon', element: 'icon'}}
        className={classNames('u-pointer u-warning-color', css(styles.icon))}
        icon="warning"
      />
    </Popover>
  );
}

const styles = StyleSheet.create({
  icon: {
    fontSize: 20,
    verticalAlign: 'middle',
  },
});
